export default "__VITE_ASSET__2124ac2c__"